import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Paper,
    Divider,
    Chip,
    Checkbox,
    FormGroup,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Badge,
    Tooltip,
    Avatar,
    Card, Stack, Alert,
    CardContent,
    LinearProgress,
    alpha
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveIcon from '@mui/icons-material/Save';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import TodayIcon from '@mui/icons-material/Today';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PrintIcon from '@mui/icons-material/Print';
import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../../../../lib/axios';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WeeklyPrint from './WeeklyPrint';
import WeeklywisePrint from '../../Operations/WeeklywiseStation/WeeklywisePrint';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StyledPaper = styled(Paper)(({ theme }) => ({
    transition: 'none',
}));

const GradientHeader = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: theme.spacing(1),
    color: 'white',
}));

const MealIcon = ({ type }) => {
    const icons = {
        breakfast: <BakeryDiningIcon />,
        lunch: <LunchDiningIcon />,
        snack: <FastfoodIcon />,
        dinner: <DinnerDiningIcon />
    };
    return icons[type] || <RestaurantMenuIcon />;
};

const FoodMenu = () => {
    const [selectedDay, setSelectedDay] = useState('Monday');
    const [selectedMeal, setSelectedMeal] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [searchText, setSearchText] = useState('');
    const [checkedItems, setCheckedItems] = useState({});
    const [showSuccess, setShowSuccess] = useState(false);
    const [categoryStats, setCategoryStats] = useState({});
    const [mealType, setMealType] = useState([]);
    const [foodItems, setFoodItems] = useState({});
    const [loading, setLoading] = useState(false);
    const [savedMenus, setSavedMenus] = useState({});
    const globalProperty = useSelector(selectGlobalProperty);
    const UserId = sessionStorage.getItem("UserId");

    const [openPrintPopup, setOpenPrintPopup] = useState(false);
    const years = Array.from({ length: 2 }, (_, i) => new Date().getFullYear() + i);
    const navigate = useNavigate();
    const months = [
        { value: 1, name: 'January' },
        { value: 2, name: 'February' },
        { value: 3, name: 'March' },
        { value: 4, name: 'April' },
        { value: 5, name: 'May' },
        { value: 6, name: 'June' },
        { value: 7, name: 'July' },
        { value: 8, name: 'August' },
        { value: 9, name: 'September' },
        { value: 10, name: 'October' },
        { value: 11, name: 'November' },
        { value: 12, name: 'December' }
    ];

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const fetchMealTypesForDropdown = async () => {
        try {
            const response = await axiosInstance.post('MstFood/GetdrpMstMealType', {
                Flag: '',
            });
            if (response.data.Status === 0) {
                const transformed = response.data.Data.map((item) => ({
                    Id: item.MealTypeId,
                    Name: item.MealTypeName,
                }));
                setMealType(transformed);
            } else {
                setMealType([]);
            }
        } catch (error) {
            toast.error('Error loading meal types');
            setMealType([]);
        }
    };

    const fetchFoodItems = async () => {
        if (!selectedMeal || !selectedYear || !selectedMonth || !selectedDay) {
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post('MstFood/RetriveMstFoodWeekCalAll', {
                FoodWeekCalId: 0,
                PropId: globalProperty || 0,
                MealTypeId: selectedMeal,
                // YearId: selectedYear,
                // MonthId: selectedMonth,
                // MonthNm: months.find(m => m.value === selectedMonth)?.name || '',
                DayNm: selectedDay,
                Flag: "R"
            });

            if (response.data.Status === 0 && response.data.Data?.FoodWeekCalList?.length > 0) {
                const menuData = response.data.Data.FoodWeekCalList[0];

                const transformedItems = {
                    [selectedMeal]: {
                        items: menuData.FoodWeekCalList.map(item => ({
                            id: item.FoodId,
                            name: item.FoodName,
                            detailId: item.FoodWeekCalDtlId,
                            foodWeekCalId: item.FoodWeekCalId
                        }))
                    }
                };

                setFoodItems(transformedItems);

                const newCheckedItems = {};
                menuData.FoodWeekCalList.forEach(item => {
                    const key = `${selectedDay}-${selectedMeal}-${item.FoodName}`;
                    newCheckedItems[key] = item.FoodWeekCalDtlId !== 0;
                });

                setCheckedItems(newCheckedItems);

                const menuKey = `${selectedDay}-${selectedMeal}`;
                setSavedMenus(prev => ({
                    ...prev,
                    [menuKey]: menuData.FoodWeekCalList
                        .filter(item => item.FoodWeekCalDtlId !== 0)
                        .map(item => item.FoodName)
                }));

            } else {
                setFoodItems({});
                toast.info('No items found for selected criteria');
            }
        } catch (error) {
            console.error('Error fetching food items:', error);
            toast.error('Error loading food items');
            setFoodItems({});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMealTypesForDropdown();
    }, []);

    useEffect(() => {
        if (selectedMeal && selectedYear && selectedMonth && selectedDay) {
            fetchFoodItems();
        }
    }, [selectedMeal, selectedYear, selectedMonth, selectedDay]);

    useEffect(() => {
        if (foodItems[selectedMeal]) {
            const stats = {
                items: {
                    total: foodItems[selectedMeal]?.items?.length || 0,
                    selected: Object.keys(checkedItems).filter(key =>
                        key.startsWith(`${selectedDay}-${selectedMeal}`)
                    ).length
                }
            };
            setCategoryStats(stats);
        }
    }, [selectedMeal, selectedDay, checkedItems, foodItems]);

    const handleDayChange = (event) => {
        setSelectedDay(event.target.value);
    };

    const handleMealChange = (event) => {
        setSelectedMeal(event.target.value);
        setSearchText('');
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const handleCheckboxChange = (foodName) => {
        console.log('Toggling checkbox for:', foodName);
        const key = `${selectedDay}-${selectedMeal}-${foodName}`;
        setCheckedItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }));

        const item = foodItems[selectedMeal]?.items.find(i => i.name === foodName);

    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const clearSearch = () => {
        setSearchText('');
    };

    const getSelectedItems = () => {
        return Object.entries(checkedItems)
            .filter(([key, value]) => value && key.startsWith(`${selectedDay}-${selectedMeal}`))
            .map(([key]) => {
                const parts = key.split('-');
                return parts.slice(2).join('-');
            });
    };

    const handleSave = async () => {
        const selected = getSelectedItems();
        console.log('Saving menu for:', { selectedDay, selectedMeal, selectedYear, selectedMonth, selectedItems: selected });

        if (!selectedMeal || !selectedYear || !selectedMonth || !selectedDay) {
            toast.error('Please select all required fields');
            return;
        }

        // if (selected.length === 0) {
        //     toast.warning('No items selected to save');
        //     return;
        // }

        setLoading(true);

        try {
            const existingMenu = foodItems[selectedMeal]?.items[0]?.foodWeekCalId || 0;
            const monthName = months.find(m => m.value === selectedMonth)?.name || "Unknown";
            const payload = {
                FoodWeekCalId: existingMenu || 1,
                PropId: globalProperty || 0,
                MealTypeId: selectedMeal,
                YearId: selectedYear,
                MonthId: selectedMonth,
                MonthNm: monthName,
                DayNm: selectedDay,
                Status: "1",
                UserId: UserId,
                mstFoodEntities: selected.map((item, index) => {
                    const foodItem = foodItems[selectedMeal]?.items.find(i => i.name === item);
                    return {
                        FoodWeekCalDtlId: foodItem?.detailId || 1,
                        FoodWeekCalId: existingMenu || 1,
                        FoodId: foodItem?.id || 0,
                    };
                })
            };

            const response = await axiosInstance.post('MstFood/MangeMstFoodWeekCal', payload);

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Menu saved successfully');

                await fetchFoodItems();
            } else {
                toast.error(response.data.Message || 'Error saving menu');
            }
        } catch (error) {
            console.error('Error saving menu:', error);
            toast.error(error.response?.data?.Message || 'Error saving menu. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleClearAll = () => {
        const newCheckedItems = { ...checkedItems };
        Object.keys(newCheckedItems).forEach(key => {
            if (key.startsWith(`${selectedDay}-${selectedMeal}`)) {
                delete newCheckedItems[key];
            }
        });
        setCheckedItems(newCheckedItems);
        toast.info('All items cleared for this meal', {
            icon: <DeleteSweepIcon />
        });
    };

    const handleCopyToClipboard = () => {
        const selectedItems = getSelectedItems();
        const mealLabel = mealType.find(m => m.Id === selectedMeal)?.Name;
        const monthName = months.find(m => m.value === selectedMonth)?.name;
        const text = `${selectedDay}, ${monthName} ${selectedYear} - ${mealLabel}\n${'─'.repeat(20)}\n${selectedItems.join('\n')}`;

        navigator.clipboard.writeText(text).then(() => {
            toast.success('📋 Menu copied to clipboard!');
        }).catch(() => {
            prompt('Copy failed. Please copy manually:', text);
        });
    };

    const getAllItems = () => {
        return foodItems[selectedMeal]?.items || [];
    };

    const filteredItems = () => {
        const items = foodItems[selectedMeal]?.items || [];
        return items.filter(item =>
            item.name.toLowerCase().includes(searchText.toLowerCase())
        );
    };

    const selectedItems = getSelectedItems();
    const allItems = getAllItems();
    const filteredItemsList = filteredItems();
    const hasItems = filteredItemsList.length > 0;

    const handleExit = () => {
        navigate('/food-menu-table');
    }

    const handlePrint = () => {
        setOpenPrintPopup(true);
    }

    const handleClosePrintPopup = () => {
        setOpenPrintPopup(false);
    }

    const handlePrintDirect = () => {
        const printWindow = window.open('', '_blank');
        const printContent = document.getElementById('weekly-print-content').innerHTML;

        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Weekly Menu</title>
            <style>
                @page {
                    size: A4;
                    margin: 0;
                }
                body {
                    margin: 0;
                    padding: 0;
                    background: white;
                    font-family: 'Cormorant Garamond', serif;
                }
                .print-wrapper {
                    width: 210mm;
                    min-height: 297mm;
                    margin: 0 auto;
                    padding: 5mm;
                    box-sizing: border-box;
                }
                @media print {
                    body {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                }
            </style>
            <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&display=swap" rel="stylesheet">
        </head>
        <body>
            <div class="print-wrapper">
                ${printContent}
            </div>
            <script>
                window.onload = function() {
                    window.print();
                    window.onafterprint = function() {
                        window.close();
                    }
                }
            </script>
        </body>
        </html>
    `);

        printWindow.document.close();
    };

    return (
        <Box sx={{
            p: { xs: 1, sm: 2, md: 3 },
            margin: '0 auto',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            // minHeight: '100vh'
        }}>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover

            />

            <StyledPaper elevation={3} sx={{ mb: 1, overflow: 'hidden', borderRadius: 3 }}>
                <GradientHeader>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <RestaurantMenuIcon sx={{ fontSize: 22 }} />
                        <Typography variant="h6" fontWeight="bold" letterSpacing={1}>
                            Meal Planner Pro
                        </Typography>
                    </Box>
                </GradientHeader>

                <Box sx={{ p: 2, bgcolor: '#f8fafc' }}>
                    <Grid container spacing={2} alignItems="center">
                        {/* <Grid item xs={12} md={2}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <EventIcon fontSize="small" />
                                        Year
                                    </Box>
                                </InputLabel>
                                <Select
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                    label="Year"
                                    sx={{ borderRadius: 2 }}
                                    className="custom-textfield"
                                >
                                    {years.map(year => (
                                        <MenuItem key={year} value={year}>
                                            {year}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid> */}

                        {/* <Grid item xs={12} md={2}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <CalendarMonthIcon fontSize="small" />
                                        Month
                                    </Box>
                                </InputLabel>
                                <Select
                                    value={selectedMonth}
                                    onChange={handleMonthChange}
                                    label="Month"
                                    sx={{ borderRadius: 2 }}
                                    className="custom-textfield"
                                >
                                    {months.map(month => (
                                        <MenuItem key={month.value} value={month.value}>
                                            {month.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid> */}

                        <Grid item xs={12} md={3}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <TodayIcon fontSize="small" />
                                        Day
                                    </Box>
                                </InputLabel>
                                <Select
                                    value={selectedDay}
                                    onChange={handleDayChange}
                                    label="Select Day"
                                    sx={{ borderRadius: 2 }}
                                    className="custom-textfield"
                                >
                                    {days.map(day => (
                                        <MenuItem key={day} value={day}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Avatar sx={{ width: 16, height: 16, bgcolor: '#667eea', fontSize: 12 }}>
                                                    {day[0]}
                                                </Avatar>
                                                {day}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <LocalDiningIcon fontSize="small" />
                                        Meal Type
                                    </Box>
                                </InputLabel>
                                <Select
                                    value={selectedMeal}
                                    onChange={handleMealChange}
                                    label="Select Meal"
                                    sx={{ borderRadius: 2 }}
                                    className="custom-textfield"
                                >
                                    {mealType.map(meal => (
                                        <MenuItem key={meal.Id} value={meal.Id}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Avatar sx={{ width: 16, height: 16, bgcolor: '#764ba2' }}>
                                                    <MealIcon type={meal.Name?.toLowerCase()} />
                                                </Avatar>
                                                {meal.Name}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Stack
                                direction="row"
                                spacing={1}
                                justifyContent={{ xs: 'center', md: 'flex-end' }}
                                flexWrap="wrap"
                                useFlexGap
                            >
                                <Tooltip title="Save current selection">
                                    <Button
                                        variant="contained"
                                        startIcon={<SaveIcon />}
                                        onClick={handleSave}
                                        sx={{
                                            background: 'linear-gradient(45deg, #10b981, #059669)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #059669, #047857)',
                                            },
                                            borderRadius: 2,
                                            minWidth: 90
                                        }}
                                    >
                                        Save
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Clear all for this meal">
                                    <Button
                                        variant="contained"
                                        startIcon={<DeleteSweepIcon />}
                                        onClick={handleClearAll}
                                        sx={{
                                            background: 'linear-gradient(45deg, #ef4444, #dc2626)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #dc2626, #b91c1c)',
                                            },
                                            borderRadius: 2,
                                            minWidth: 90
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Print">
                                    <Button
                                        variant="contained"
                                        startIcon={<PrintIcon />}
                                        onClick={handlePrint}
                                        sx={{
                                            background: 'linear-gradient(45deg, #6366f1, #4f46e5)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #4f46e5, #4338ca)',
                                            },
                                            borderRadius: 2,
                                            minWidth: 90
                                        }}
                                    >
                                        Print
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Exit">
                                    <Button
                                        variant="contained"
                                        startIcon={<ExitToAppIcon />}
                                        onClick={handleExit}
                                        sx={{
                                            background: 'linear-gradient(45deg, #6366f1, #4f46e5)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #4f46e5, #4338ca)',
                                            },
                                            borderRadius: 2,
                                            minWidth: 90
                                        }}
                                    >
                                        Exit
                                    </Button>
                                </Tooltip>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </StyledPaper>

            {showSuccess && (
                <Alert
                    severity="success"
                    sx={{ mb: 2, borderRadius: 2 }}
                >
                    Menu saved successfully! 🎉
                </Alert>
            )}

            {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

            <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                    <StyledPaper elevation={2} sx={{ p: 1, height: '100%', borderRadius: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Avatar sx={{ bgcolor: '#667eea' }}>
                                    <MealIcon type={mealType.find(m => m.Id === selectedMeal)?.Name?.toLowerCase()} />
                                </Avatar>
                                <Typography variant="h6" fontWeight="bold" color="primary">
                                    {mealType.find(m => m.Id === selectedMeal)?.Name} Items
                                </Typography>
                            </Box>
                            <Badge badgeContent={selectedItems.length} color="success" showZero>
                                <Chip
                                    label={`${selectedItems.length}/${allItems.length}`}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                />
                            </Badge>
                        </Box>

                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search delicious items..."
                            value={searchText}
                            onChange={handleSearchChange}
                            size="small"
                            sx={{ mb: 2, borderRadius: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                                endAdornment: searchText && (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={clearSearch}>
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        <Box sx={{ maxHeight: 500, overflow: 'auto', pr: 1 }}>
                            {hasItems ? (
                                <Card
                                    sx={{
                                        mb: 1,
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <CardContent sx={{ p: 1, pb: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant="subtitle1" fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                                                Food Items
                                            </Typography>
                                            <Chip
                                                label={`${selectedItems.length}/${allItems.length}`}
                                                size="small"
                                                color={selectedItems.length === allItems.length ? "success" : "default"}
                                            />
                                        </Box>

                                        <LinearProgress
                                            variant="determinate"
                                            value={allItems.length > 0 ? (selectedItems.length / allItems.length) * 100 : 0}
                                            sx={{
                                                mb: 1,
                                                height: 4,
                                                borderRadius: 2,
                                                bgcolor: alpha('#10b981', 0.1),
                                                '& .MuiLinearProgress-bar': {
                                                    bgcolor: '#10b981'
                                                }
                                            }}
                                        />

                                        <FormGroup sx={{ p: 0, m: 0 }}>
                                            <Grid container spacing={0} sx={{ p: 0, m: 0, maxHeight: 400, overflowY: 'auto' }}>
                                                {filteredItemsList.filter(item => item.name !== '').map((item) => {
                                                    const itemKey = `${selectedDay}-${selectedMeal}-${item.name}`;
                                                    return (
                                                        <Grid item xs={12} sm={4} key={item.id || itemKey} sx={{ p: 0, m: 0 }}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={checkedItems[itemKey] || false}
                                                                        onChange={() => handleCheckboxChange(item.name)}
                                                                        sx={{
                                                                            p: 0,
                                                                            color: '#10b981',
                                                                            '&.Mui-checked': {
                                                                                color: '#10b981',
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            m: 0,
                                                                            fontWeight: checkedItems[itemKey] ? 600 : 500,
                                                                            color: checkedItems[itemKey] ? '#10b981' : 'inherit',
                                                                        }}
                                                                    >
                                                                        {item.name}
                                                                    </Typography>
                                                                }
                                                                sx={{
                                                                    width: '100%',
                                                                    m: 0,
                                                                    p: 0,
                                                                    borderRadius: 0,
                                                                    '&:hover': {
                                                                        bgcolor: alpha('#667eea', 0.1),
                                                                    },
                                                                    bgcolor: checkedItems[itemKey]
                                                                        ? alpha('#10b981', 0.05)
                                                                        : 'transparent',
                                                                }}
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </FormGroup>
                                    </CardContent>
                                </Card>
                            ) : (
                                <Box sx={{ textAlign: 'center', py: 8 }}>
                                    <SearchIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
                                    <Typography color="text.secondary">
                                        {selectedMeal ? 'No items found matching "' + searchText + '"' : 'Please select meal type'}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </StyledPaper>
                </Grid>

                <Grid item xs={12} md={5}>
                    <StyledPaper
                        elevation={2}
                        sx={{
                            p: 2,
                            height: '100%',
                            borderRadius: 3,
                            background: 'linear-gradient(135deg, #f0f9ff 0%, #e6f0fa 100%)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Avatar sx={{ bgcolor: '#10b981' }}>
                                <CheckCircleIcon />
                            </Avatar>
                            <Typography variant="h6" fontWeight="bold" color="#2563eb">
                                Selected Items
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 1 }} />

                        <Box sx={{ minHeight: 400 }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    mb: 1,
                                    bgcolor: 'white',
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: '#2563eb'
                                }}
                            >
                                <Typography variant="subtitle1" fontWeight="bold" color="#2563eb" gutterBottom>
                                    {selectedDay} - {months.find(m => m.value === selectedMonth)?.name} {selectedYear}
                                </Typography>
                                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                    {mealType.find(m => m.Id === selectedMeal)?.Name}
                                </Typography>

                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((item, index) => (
                                            <Chip
                                                key={index}
                                                label={item}
                                                onDelete={() => {
                                                    const itemKey = `${selectedDay}-${selectedMeal}-${item}`;
                                                    setCheckedItems(prev => {
                                                        const newState = { ...prev };
                                                        delete newState[itemKey];
                                                        return newState;
                                                    });
                                                }}
                                                sx={{
                                                    bgcolor: 'white',
                                                    border: '1px solid #2563eb',
                                                    height: 27,
                                                    fontWeight: 500,
                                                    '& .MuiChip-deleteIcon': {
                                                        color: '#ef4444',
                                                        '&:hover': { color: '#dc2626' }
                                                    },
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <Box sx={{
                                            py: 6,
                                            width: '100%',
                                            textAlign: 'center',
                                            bgcolor: alpha('#2563eb', 0.02),
                                            borderRadius: 2
                                        }}>
                                            <RestaurantMenuIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
                                            <Typography color="text.secondary">
                                                No items selected yet
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Check some items from the list
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Paper>

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Card sx={{ bgcolor: alpha('#10b981', 0.1), borderRadius: 2 }}>
                                        <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                            <Typography variant="h4" color="#10b981" fontWeight="bold">
                                                {selectedItems.length}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Selected Items
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card sx={{ bgcolor: alpha('#667eea', 0.1), borderRadius: 2 }}>
                                        <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                            <Typography variant="h4" color="#667eea" fontWeight="bold">
                                                {allItems.length}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Total Available
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 2 }}>
                                <Typography variant="body2" color="text.secondary" gutterBottom>
                                    Selection Progress
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={allItems.length > 0 ? (selectedItems.length / allItems.length) * 100 : 0}
                                    sx={{
                                        height: 8,
                                        borderRadius: 4,
                                        bgcolor: alpha('#10b981', 0.1),
                                        '& .MuiLinearProgress-bar': {
                                            background: 'linear-gradient(90deg, #10b981, #059669)'
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </StyledPaper>
                </Grid>
            </Grid>

            <Dialog
                open={openPrintPopup}
                onClose={handleClosePrintPopup}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        width: '350mm',
                        maxWidth: '350mm',
                        margin: '0 auto',
                        '@media print': {
                            boxShadow: 'none',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            margin: 0,
                            padding: 0,
                        }
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        p:0,
                        m: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        '@media print': {
                            display: 'none'
                        }
                    }}
                >
                    <Typography variant="h6">Weekly Menu Preview</Typography>
                    <DialogActions sx={{ justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            startIcon={<PrintIcon />}
                            onClick={() => window.print()}
                            sx={{
                                background: 'linear-gradient(45deg, #6366f1, #4f46e5)',
                                '&:hover': {
                                    background: 'linear-gradient(45deg, #4f46e5, #4338ca)',
                                },
                            }}
                        >
                            Print
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleClosePrintPopup}
                        >
                            Close
                        </Button>
                    </DialogActions>
                    {/* <IconButton
                        onClick={handleClosePrintPopup}
                        sx={{
                            '@media print': {
                                display: 'none'
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton> */}
                </DialogTitle>
                <DialogContent
                    dividers
                    sx={{
                        p: 0,
                        overflow: 'auto',
                        '@media print': {
                            overflow: 'visible',
                            padding: 0,
                        }
                    }}
                >
                    <WeeklyPrint
                        globalProperty={globalProperty}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default FoodMenu;